import {
  mergeExamenAbrirPayload,
  leerExamenAbrirPendiente,
  limpiarExamenAbrirPendiente,
  findChatPorProspecto,
  nombreRutaTwilioExamen,
} from '@/utils/examenUbicacionNotify'

/**
 * Abrir chat desde notificación de examen (folio en buscador + verChat).
 * Sobrescribir en la vista: examenListasChats, examenRecargarChats, examenNombreRuta.
 */
export default {
  data: () => ({
    pendingExamenAbrir: null,
    examenAbrirCargaLista: false,
  }),

  watch: {
    '$route.query': {
      handler () {
        this.syncPendingExamenDesdeRuta()
      },
    },
  },

  methods: {
    examenNombreRuta () {
      return nombreRutaTwilioExamen(this.pendingExamenAbrir && this.pendingExamenAbrir.escuela)
    },

    examenListasChats () {
      return []
    },

    examenRecargarChats () {
      return Promise.resolve()
    },

    examenTieneListaCargada () {
      const listas = this.examenListasChats()
      return listas.some(l => Array.isArray(l) && l.length > 0)
    },

    syncPendingExamenDesdeRuta () {
      const merged = mergeExamenAbrirPayload(this.$route.query, leerExamenAbrirPendiente())
      if (!merged) {
        this.pendingExamenAbrir = null
        limpiarExamenAbrirPendiente()
        return
      }
      this.pendingExamenAbrir = merged
      if (merged.folio) {
        this.buscarUsuario = String(merged.folio).trim()
      } else if (merged.telefono) {
        this.buscarUsuario = String(merged.telefono).trim()
      }
    },

    tryAbrirChatExamenPendiente () {
      if (!this.pendingExamenAbrir) {
        this.syncPendingExamenDesdeRuta()
      }
      if (!this.pendingExamenAbrir) return

      const listas = this.examenListasChats()
      let chat = null
      for (const lista of listas) {
        if (!Array.isArray(lista) || !lista.length) continue
        chat = findChatPorProspecto(lista, this.pendingExamenAbrir)
        if (chat) break
      }

      if (!chat) {
        if (!this.examenTieneListaCargada() && !this.examenAbrirCargaLista) {
          this.examenAbrirCargaLista = true
          Promise.resolve(this.examenRecargarChats()).finally(() => {
            this.$nextTick(() => {
              this.examenAbrirCargaLista = false
              this.tryAbrirChatExamenPendiente()
            })
          })
        }
        return
      }

      const ruta = nombreRutaTwilioExamen(this.pendingExamenAbrir.escuela)
      this.pendingExamenAbrir = null
      limpiarExamenAbrirPendiente()
      const q = this.$route.query || {}
      if (q.folio || q.tel || q.idprospectos) {
        this.$router.replace({ name: ruta, query: {} }).catch(() => {})
      }
      this.verChat(chat)
    },
  },
}
